const APP_ROUTES = {
  HOME: "/",
  CALENDAR: "/calendar",
  CALENDAR_PERPETUAL: "/perpetual-calendar",
};

export default APP_ROUTES;
